import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderSearchService {
  public _queryParams: BehaviorSubject<Params>;
  public queryParams$: Observable<Params>;
  public isBusy$: Observable<boolean>;
  private oldQueryParams: Params;
  private isBusy: BehaviorSubject<boolean>;

  constructor() {
    this._queryParams = new BehaviorSubject<Params>(undefined);
    this.queryParams$ = this._queryParams.asObservable();
    this.isBusy = new BehaviorSubject<boolean>(false);
    this.isBusy$ = this.isBusy.asObservable();
  }

  getQueryParams() {
    return this._queryParams.value;
  }

  setQueryParams(queryParams: Params) {
    if (JSON.stringify(queryParams) === JSON.stringify(this.oldQueryParams)) {
      this.setBusy(false);
    }
    this.oldQueryParams = queryParams;
    this._queryParams.next(queryParams);
  }

  clearQueryParams() {
    this.oldQueryParams = undefined;
    this._queryParams.next(undefined);
  }

  clearFindParams() {
    const params = JSON.parse(JSON.stringify(this._queryParams.getValue()));
    if (params?.prefix === 'title') {
      delete params?.value;
    }
    this._queryParams.next(params);
  }

  clearWhenParams() {
    const params = JSON.parse(JSON.stringify(this._queryParams.getValue()));
    delete params.beginDate;
    delete params.endDate;
    this._queryParams.next(params);
  }

  clearWhereParams() {
    const params = JSON.parse(JSON.stringify(this._queryParams.getValue()));
    if (params?.prefix === 'location') {
      delete params?.regions;
      if (params?.value) {
        delete params?.value;
      }
      delete params?.prefix;
    }
    if (params?.region) {
      delete params?.region;
    }
    delete params?.province;
    delete params?.city;
    delete params?.municipality;
    delete params?.latitude;
    delete params?.longitude;
    this._queryParams.next(params);
  }

  setBusy(busy: boolean) {
    this.isBusy.next(busy);
  }
}
